import { Injectable } from '@angular/core';
import { FormSection } from '@state/form/form.model';

import { FormWizardStore } from './form-wizard.store';

@Injectable({ providedIn: 'root' })
export class FormWizardService {
  constructor(private formWizardStore: FormWizardStore) {}

  reset(): void {
    this.formWizardStore.reset();
  }

  navigateSections(
    direction: 'next' | 'back',
    activeIndex: { position: number },
    sections?: FormSection[]
  ): void {
    let i: number;
    if (direction === 'next') i = activeIndex.position + 1;
    if (direction === 'back') i = activeIndex.position - 1;
    this.formWizardStore.update({
      activeIndex: { position: i },
      activeSection: sections[i]
    });

    // Scroll to top on section change
    window.scrollTo(0, 0);
  }
}
